import React, { useState } from 'react';
import {Filters} from './Filters';
import {useAnalytics} from "./hooks/useAnalytics";
import {useAnalyticsFilterHandler} from "./Filters/hooks/useAnalyticsFilterHandler";
import {LineChart} from "components/Analytics/LineChart";
import {Totals} from "./Totals";
import {Table} from "./Table";
import {countryColumns} from "components/Analytics/constants";
import {Map} from "./Map";
import {LoadingSpinner} from 'components/Analytics/Filters/tabs/LoadingSpinner';
import {registerCharts} from 'components/Analytics/ChartConfig';
import {Container, Breadcrumbs, Breadcrumb, NextArrow} from 'components/Analytics/Filters/tabs/AnalyticTabs.styled';
import styled from "styled-components";
import Filter from "assets/filter.svg";
import { Settings } from './Settings';
import {FiltersModal} from "components/Analytics/Filters/modal";
import {FilterChartView} from "components/Analytics/FilterChartView";
import "components/Analytics/Filters/dropdown/DropdownSelect.css"

registerCharts();

export const Analytics = () => {
    const [isOpen, setIsOpen] = useState(false);

    const {filters, onSelectFilter, onResetFilters} = useAnalyticsFilterHandler();

    const {analytics, fetching} = useAnalytics(
        filters.filterArtistIds,
        filters.filterPlatformIds,
        filters.filterLabelIds,
        filters.filterTerritoryIds,
        filters.filterReleaseIds,
        filters.filterTrackIds,
        filters.filterDate
    );

    if (!analytics && fetching) {
        return <LoadingSpinner/>;
    }

    return (
        <Container>
            <HeaderContainer>
                <Breadcrumbs style={{justifyContent: "start"}} onClick={() => window.history.back()}>
                    <Breadcrumb>Analytics</Breadcrumb>
                    <NextArrow color="rgba(0, 0, 0, 0.5)" height="15px"/>
                    <Breadcrumb $isActive={true}>DSP</Breadcrumb>
                </Breadcrumbs>

                {isOpen && <FiltersModal setIsOpen={setIsOpen} />}

                <FilterBox
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <Filter/>
                    Filter
                </FilterBox>
            </HeaderContainer>

            <Filters
                {...filters}
                onSelectFilter={onSelectFilter}
                onResetFilters={onResetFilters}
            />
            {/*<Settings />*/}
            {/*<FilterChartView />*/}
            <Totals
                totals={analytics?.totals.value ?? ''}
                growthpct={analytics?.totals.growth_pct ?? 0}
            />
            <LineChart timeseries={analytics?.timeseries} />
            {/*<Streams dsp={mockAnalytics.dsp} />*/}
            <Map countries={analytics?.countries} />
            <Table columns={countryColumns} data={analytics?.countries} />
        </Container>
    );
};

const HeaderContainer = styled(Container)`
    flex-direction: row;
    justify-content: space-between;
    padding: 28px 20px 0 0 !important;
    position: relative;

    @media (max-width: 768px) {
        padding: 0 !important;
    }
`

const FilterBox = styled.div`
    display: flex;
    gap: 5px;
    font-family: SF Pro Display;
    font-weight: 400;
    font-size: 15px;
    line-height: 15px;
    color: rgba(103, 119, 255, 1);
    cursor: pointer;
`;